import React from 'react';
import { SECTION_CATEGORIES } from '../../data/sectionTypes';
import WeldedIDrawing from './WeldedIDrawing';
import UniversalIDrawing from './UniversalIDrawing';
import ParallelFlangeChannelDrawing from './ParallelFlangeChannelDrawing';

export default function SectionDrawing({ section }) {
  if (!section) return null;

  switch (section.category) {
    case SECTION_CATEGORIES.WELDED_BEAMS:
    case SECTION_CATEGORIES.WELDED_COLUMNS:
      return <WeldedIDrawing section={section} />;
    case SECTION_CATEGORIES.UNIVERSAL_BEAMS:
    case SECTION_CATEGORIES.UNIVERSAL_COLUMNS:
      return <UniversalIDrawing section={section} />;
    case SECTION_CATEGORIES.PARALLEL_FLANGE_CHANNELS:
      return <ParallelFlangeChannelDrawing section={section} />;
    default:
      return <div>Drawing not available for this section type.</div>;
  }
} 